var map = {
	"./symbol_0.png": "dec8",
	"./symbol_1.png": "fc32",
	"./symbol_10.png": "e4a2",
	"./symbol_11.png": "ab92",
	"./symbol_12.png": "f7fc",
	"./symbol_2.png": "b656",
	"./symbol_3.png": "d449",
	"./symbol_4.png": "3a51",
	"./symbol_5.png": "6d1b",
	"./symbol_6.png": "3d31",
	"./symbol_7.png": "7819",
	"./symbol_8.png": "a711",
	"./symbol_9.png": "0534"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0abc";